"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "zelo-buon-persico": {
    "4d945ebe": [{
      "hkey": "f2396f7a",
      "slug": "zelo-buon-persico",
      "name": "Zelo Buon Persico",
      "primary": true,
      "skipSearch": false
    }],
    "cascina-giussana": [{
      "hkey": "f2396f7a",
      "slug": "zelo-buon-persico",
      "name": "Zelo Buon Persico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b9337ef2": [{
      "hkey": "f2396f7a",
      "slug": "zelo-buon-persico",
      "name": "Zelo Buon Persico",
      "primary": true,
      "skipSearch": false
    }],
    "cascina-molinetto": [{
      "hkey": "f2396f7a",
      "slug": "zelo-buon-persico",
      "name": "Zelo Buon Persico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;